module.exports = __webpack_public_path__ + "static/digipay-pay-your-bills-320a457d3adc06f2cf4c0c64bb3cdd5f.png";